import { render, staticRenderFns } from "./SurveyArea.vue?vue&type=template&id=aff8c824"
import script from "./SurveyArea.vue?vue&type=script&lang=js"
export * from "./SurveyArea.vue?vue&type=script&lang=js"
import style0 from "./SurveyArea.vue?vue&type=style&index=0&id=aff8c824&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports